exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".module-notification-item {\n  padding: 16px 24px;\n  background: #4caf50;\n  box-shadow: 0 6px 6px 0 #ededed, 0 0 6px 0 #daeaff;\n  color: #FFFFFF;\n  margin-bottom: 16px;\n}\n.module-notification-item.error {\n  background: #FF635F;\n}\n", ""]);

